import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e5e5;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #6b7280;
  border-radius: 4px;
  transition: all 0.2s;
  
  &:hover {
    background-color: #f3f4f6;
    color: #374151;
  }
`;

export const Content = styled.div`
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
`;

export const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #f0f9f4;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Description = styled.p`
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.4;
`;

export const PhoneNumber = styled.div`
  font-weight: 600;
  color: #1f2937;
  font-size: 16px;
  padding: 8px 16px;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`;

export const CodeInputContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  width: 100%;
  max-width: 300px;
`;

export const CodeInput = styled.input`
  width: 40px;
  height: 48px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  background-color: white;
  transition: all 0.2s;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  &:invalid {
    border-color: #ef4444;
  }
`;

export const ResendContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
`;

export const CountdownText = styled.span`
  color: #6b7280;
  font-size: 14px;
`;

export const ResendButton = styled.button`
  background: none;
  border: none;
  color: #3b82f6;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
  
  &:hover {
    background-color: #eff6ff;
    color: #2563eb;
  }
`;

export const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  
  .spinning {
    animation: ${spin} 1s linear infinite;
  }
`;

export const Footer = styled.div`
  padding: 20px 24px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  gap: 12px;
  
  .spinning {
    animation: ${spin} 1s linear infinite;
  }
`;
